import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { Afiliaciones } from '../../../../models/afiliaciones';
import { AfiliacionesService } from '../../../../services/afiliaciones.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-afiliaciones-list',
  templateUrl: './afiliaciones-list.component.html',
  styleUrls: ['./afiliaciones-list.component.css']
})
export class AfiliacionesListComponent implements OnInit {

  @Input() personalId: number;
  @Input() afiliaciones: Afiliaciones[];
  @Input() permisoEdicion: boolean = true;
  @Output() VisualizarDetalle = new EventEmitter<Afiliaciones>();
    
  afiliacionesOri: Afiliaciones[];
  afiliacionesGrupo: Afiliaciones[];
  filtroDesde: string;
  filtroHasta: string;
  agrupar: boolean = false;

  constructor(private afiliacionesService: AfiliacionesService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.afiliacionesOri = this.afiliaciones;
    this.inicializaFiltros();
    
    this.filtrarAfiliaciones();
  }

  inicializaFiltros()
  {
    let fechaHoy = new Date();
    let fechaIni = new Date();
    fechaIni.setDate(fechaIni.getDate() - 30);

    let mesString = ('0' + (fechaIni.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    let diaString = ('0' + (fechaIni.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroDesde = (fechaIni.getFullYear()).toString() + "-" + mesString + "-" + diaString ;

    mesString = ('0' + (fechaHoy.getMonth() + 1).toString()).slice(-2); //agrega cero por si es menor de 10
    diaString = ('0' + (fechaHoy.getDate()).toString()).slice(-2); //agrega cero por si es menor de 10
    this.filtroHasta = (fechaHoy.getFullYear()).toString() + "-" + mesString + "-" + diaString ;
  }

  filtrarAfiliaciones()
  {
    let desde = moment(this.filtroDesde, "YYYY/MM/DD").toDate();
    let hasta = moment(this.filtroHasta, "YYYY/MM/DD").toDate();
    
    this.afiliaciones = this.afiliacionesOri.filter(i => Date.parse(i.desde) <= hasta.getTime() && Date.parse(i.hasta) >= desde.getTime());
  }

  onChangeAgrupamiento()
  {
    //Cambia lista
    if (this.agrupar == true)
    {
      if (this.afiliacionesGrupo == undefined)
      {
        this.afiliacionesService.getByPersonal(this.personalId, true).subscribe(
          data =>
          {
            data.forEach((currentValue,index,arr) => {
              currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
              currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
            });

            this.afiliacionesGrupo = data;
            this.afiliaciones = this.afiliacionesGrupo;
          });

      } else
      {
        this.afiliaciones = this.afiliacionesGrupo;
      }
      
    } else
    {
      this.filtrarAfiliaciones();
    }
  }

  onChangeFiltros()
  {
    this.filtrarAfiliaciones();
  }

  visualizarDetalle(afiliacion)
  {
    this.VisualizarDetalle.emit(afiliacion);
  }

  add()
  {
    let afiliacion: Afiliaciones = { id: 0, personal: this.personalId, desde: new Date().toString(), hasta: new Date("2999-12-31T23:59:59").toString()};
    this.VisualizarDetalle.emit(afiliacion);
  }

}

